require("trix")
require("@rails/actiontext")

import "./timeago"

import "./rails"
import "./trix"